import { Button, Group, Textarea } from "@mantine/core";
import { useState, type ReactNode } from "react";

import { ErrorAlert } from "../ErrorAlert";
import classes from "./scripts.module.css";
import { GENERATE_SCRIPT } from "./ScriptActions";
import { MIN_BRIEF } from "./use-script-jobs";

export interface ScriptOverlayProps {
  /** Live's brief placeholder for the tool ("Describe what your avatars should say..."). */
  placeholder: string;
  /** At the footer's left: the tool's product picker. */
  footerLeft?: ReactNode;
  /** The start is on its way. */
  pending: boolean;
  /** A start the API refused. */
  error: unknown;
  onGenerate: (brief: string) => void;
  onCancel: () => void;
}

/**
 * Live's "Generate Script" overlay (`script-generation/overlay`, captures script-tools-224/04 to
 * 09): over the composer's face, its title, the brief, and at the footer the tool's product
 * picker, "Cancel" and "Generate Script", greyed until the brief has ten characters. Each opening
 * starts with an empty brief, as live's does; live types its placeholder out, ours shows it whole.
 */
export function ScriptOverlay(props: ScriptOverlayProps) {
  const { placeholder, footerLeft, pending, error, onGenerate, onCancel } = props;
  const [brief, setBrief] = useState("");
  return (
    <section className={classes.overlay} aria-label={GENERATE_SCRIPT}>
      <h2 className={classes.title}>{GENERATE_SCRIPT}</h2>
      <Textarea
        className={classes.brief}
        variant="unstyled"
        aria-label={placeholder}
        placeholder={placeholder}
        autosize
        minRows={3}
        disabled={pending}
        value={brief}
        onChange={(event) => setBrief(event.currentTarget.value)}
      />
      {error === null ? null : <ErrorAlert error={error} />}
      <div className={classes.footer}>
        <div>{footerLeft}</div>
        <Group gap={8} wrap="nowrap">
          <Button variant="outline" disabled={pending} onClick={onCancel}>
            Cancel
          </Button>
          <Button
            loading={pending}
            disabled={brief.trim().length < MIN_BRIEF}
            onClick={() => onGenerate(brief)}
          >
            {GENERATE_SCRIPT}
          </Button>
        </Group>
      </div>
    </section>
  );
}
